<template>
  <!-- 预售活动管理 -->
  <div class="presell">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="getTableData('refresh')" :crumbsList="['促销管理', $route.meta.title]">
      <template slot="controls">
        <el-link @click="explain = true" style="margin-right: 10px;" icon="el-icon-question" :underline="false"
          type="warning">操作说明</el-link>
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">
          添加</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>

      </template>
    </search-bar>
    <!-- 数据展示 -->
    <!-- @selection-change="selectionChange" -->
    <el-table :data="tableData" stripe border height="calc(100% - 130px)" tooltip-effect="dark">
      <el-table-column label="序号" align="center" width="55">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column prop="ActivityId" align="center" show-overflow-tooltip label="活动编号">
      </el-table-column>
      <el-table-column prop="Title" align="center" show-overflow-tooltip label="标题">
      </el-table-column>
      <el-table-column prop="AddTime" label="创建时间" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="StartTime" label="开始时间" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="EndTime" label="结束时间" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="Status" show-overflow-tooltip label="状态">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Status == 2">已启用</el-tag>
          <el-tag type="warning" v-else-if="scope.row.Status == 1">已禁用</el-tag>
          <el-tag type="info" v-else-if="scope.row.Status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.Status == 1" type="warning" style="padding: 2px 3px" plain
            @click="handleEdit(scope)">编辑</el-button>
          <el-button v-if="scope.row.Status == 2" type="primary" style="padding: 2px 3px" plain
            @click="handleEdit(scope)">查看</el-button>
          <el-button v-if="scope.row.Status == 1" type="success" style="padding: 2px 3px" plain
            @click="changeStatus(scope, 2)">上架</el-button>
          <el-button v-if="scope.row.Status == 2" type="warning" style="padding: 2px 3px" plain
            @click="changeStatus(scope, 1)">下架</el-button>
          <el-button v-if="scope.row.Status == 1" type="danger" style="padding: 2px 3px" plain
            @click="changeStatus(scope, 0)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"></pagination>

    <el-dialog title="操作说明" :visible.sync="explain" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="70%">
      <div class="explain-text">
        <p>该界面商城预售专区活动数据</p>
        <p>新增：新增预售活动，按照表单信息填写即可</p>
        <p>下架：禁用该预售活动，禁用后该活动可进行编辑</p>
        <p>备注：预售订单查看在 <span style="font-weight:bold;">订单列表</span> 界面中查看，预售订单需要手动审核</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "presell",
  data() {
    return {
      /**用户信息 */
      entId: '',

      /**搜索表单 */
      search: {
        status: "99",
        name: "",//查询关键词
        type: '预售',
        startDate: '',
        endDate: ''
      },

      /**表格数据 */
      tableData: [],

      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**使用说明 */
      explain: false
    }
  },
  mounted() {
    this.entId = localStorage.getItem('entId')
    this.getTableData('refresh')
  },
  methods: {
    /**店家添加商品 */
    handleAdd() {
      // this.addDialog = true
      this.$router.push({
        path: "presellForm",
        query: {
          type: 'Add',
          id: ''
        }
      });
    },

    /**获取数据 */
    getTableData(type = "") {
      if (type == "refresh") {
        this.currPage = 1;
        this.search.status = "99"
        this.search.name = ""//查询关键词
        this.search.type = '预售'//固定类型
        this.search.startDate = ''
        this.search.endDate = ''
      } else if (type == "search") {
        this.currPage = 1;
      }

      this.$request({
        url: "/Management/ActivityAdmin/GetActivityList",
        method: "post",
        data: {
          type: this.search.type,//默认传预售
          val: this.search.name,//查询关键字
          status: this.search.status,//状态99 全部
          startDate: this.search.startDate,
          endDate: this.search.endDate,
          pageIndex: this.currPage,
          pageSize: this.pageSize
        },
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dataList
            this.allPage = res.recordCount
          }
        })
        .catch((err) => {
          window.console.log(err);
        });

    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize2 = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage2 = val;
      this.getTableData();
    },

    /**点击编辑 */
    handleEdit({ row }) {
      this.$router.push({
        path: "presellForm",
        query: {
          type: 'Update',
          id: row.ActivityId
        }
      });
    },

    /**状态修改，0 删除 1 禁用 2 启用 */
    changeStatus({ row }, status) {
      let msg = '确定要执行操作吗?'
      let msgType = 'info'
      if (status == 1) {
        msg = '确定下架吗?'
        msgType = 'warning'
      } else if (status == 2) {
        msg = '确定上架吗?'
        msgType = 'success'
      } else if (status == 0) {
        msg = '确定删除吗?'
        msgType = 'error'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: msgType
      }).then(() => {
        this.$request({
          method: "post",
          url: "/Management/ActivityAdmin/AuditActivityStatusApi",
          data: {
            activityId: row.ActivityId,
            status
          }
        }).then((res) => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.getTableData()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err)
        });
      }).catch(() => { });
    }

  }
}
</script>

<style scoped>
.presell {
  width: 100%;
  height: 100%;
}
</style>